export var ReceptionScenario;
(function (ReceptionScenario) {
    ReceptionScenario["AdmittedToHospital"] = "admitted-to-hospital";
    ReceptionScenario["ReceivedIntoGuardianship"] = "received-into-guardianship";
    ReceptionScenario["CommunityPatient"] = "became-a-community-patient";
})(ReceptionScenario || (ReceptionScenario = {}));
//# sourceMappingURL=miscellaneousForm.js.map